module.exports = __webpack_public_path__ + "static/media/4z6_website_logo_sup_HKIS.98273d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4z6_website_logo_sup_HKIS.jpg
// module id = 84
// module chunks = 0